import { push } from 'connected-react-router';
import configureStore from 'store';
import { isObject } from './common';

export const pushProgressive = (pathname: string) => {
  const { store } = configureStore();
  store.dispatch(push(pathname));
};

const InAppRoutes = {
  Login: '/login',
  CreateAccount: '/create-account',
  Invitation: '/invitation',
  Home: '/home',
  AdminHubCreate: '/admin/hubs/create',
  AdminHubEdit: '/admin/hubs/edit/:hubId',
  AdminAuthoringHome: '/admin/authoring',
  AdminAuthoringArchiveHome: '/admin/authoring?archive=TRUE',
  AdminKitCreate: '/admin/kits/create',
  AdminKitEdit: '/admin/kits/edit/:kitId',
  AdminTemplateCreate: '/admin/templates/create/:templateType',
  AdminTemplateEdit: '/admin/templates/edit/:templateId',
  AdminConversationPrompts: '/admin/conversation-prompts',
  AdminReachPartners: '/admin/reach-partners',
  DiscoverHub: '/discover/hub/:hubId',
  DiscoverKit: '/discover/kit/:kitId',
  DiscoverItem: '/discover/item/:itemId',
  Root: '/',
  VideoPlayer: '/v/player',
  ConversationPromptCreate: '/admin/conversation-prompts/create',
  ConversationPromptEdit: '/admin/conversation-prompts/edit/:conversationPromptId',

  getString(
    r: string,
    replacer?:
      | string
      | number
      | {
          [key in
            | 'orgId'
            | 'token'
            | 'userUniqId'
            | 'orgUniqId'
            | 'orgId'
            | 'devotionalId'
            | 'userId'
            | 'groupId'
            | 'itemId'
            | 'kitId'
            | 'templateType'
            | 'explorerId'
            | 'templateId'
            | 'code'
            | 'selectedTab']?: string | number;
        },
  ) {
    let str = r;
    if (replacer) {
      if (str.startsWith('/')) {
        str = str
          .split('/')
          .map((s) =>
            isObject(replacer)
              ? s.includes(':') && replacer[s.substr(1)]
                ? `${replacer[s.substr(1)]}`
                : s
              : s.includes(':')
                ? `${replacer}`
                : s,
          )
          .join('/');
      }

      if (str.includes('://')) {
        // handle replacer for full url
        const matches = str.split('://');
        const pre = `${matches[0]}://${matches[1].substring(0, matches[1].indexOf('/'))}`;
        str = matches[1].substring(matches[1].indexOf('/'));
        str = str
          .split('/')
          .map((s) =>
            isObject(replacer)
              ? s.includes(':') && replacer[s.substr(1)]
                ? `${replacer[s.substr(1)]}`
                : s
              : s.includes(':')
                ? `${replacer}`
                : s,
          )
          .join('/');
        str = `${pre}${str}`;
      }
    }
    return str;
  },
  stripOptionalParams(r: string) {
    let str = r;
    str = str
      .split('/')
      .map((s) => (s.startsWith(':') && s.endsWith('?') ? null : s))
      .join('/');
    return str;
  },
};

export default InAppRoutes;
